// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__rOHOM","upload":"Small_upload__NiWjn","imageWrap":"Small_imageWrap__2aeLl","removeBtn":"Small_removeBtn__U-LLW"};